module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isvisible) ? _c('el-dialog', _vm._b({
    class: _vm.classes,
    attrs: {
      "visible": _vm.isvisible,
      "append-to-body": "",
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "update:visible": function($event) {
        _vm.isvisible = $event
      },
      "close": _vm.close,
      "opened": _vm.opened
    }
  }, 'el-dialog', _vm.$attrs, false), [_c('div', {
    staticClass: "rt-dialog-title-wrapper",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("title", function() {
    return [_c('div', {
      staticClass: "rt-dialog-title"
    }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), (_vm.showClose) ? _c('rt-button', {
      attrs: {
        "icon-name": "rt-base-close",
        "text": "",
        "icon-size": "24",
        "color-type": "info",
        "type": "plain"
      },
      on: {
        "click": _vm.close
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-dialog-content-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    staticClass: "rt-dialog-footer-wrapper",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "rt-dialog-footer-buttons"
    }, [_c('rt-button', {
      on: {
        "click": _vm.resetData
      }
    }, [_vm._v("\n          重置\n        ")]), _vm._v(" "), _c('rt-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.confirm
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$tx('确认', 'xpc.dialog.confirm')) + "\n        ")])], 1)]
  })], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26911eda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/dialog/rtDialog.vue
// module id = 2041
// module chunks = 228